import APIClient from '@/shared/http/clients/api'

const resourceName = 'RECorretor'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const GetAllCorretores = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/${id}`, config)
const PostTipoCorretor = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/tipo/corretor`, data, config)
const PutUpdateBrokerAdm = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/Edit`, data, config)
const GetCorretorByName = (nome, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/getCorretorByName/${nome}`, data, config)

const BrowerRepository = {
  GetAll,
  GetAllCorretores,
  Create,
  PostTipoCorretor,
  PutUpdateBrokerAdm,
  Update,
  Delete,
  GetCorretorByName
}

export default BrowerRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/broker.js